import { Pagination } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { useMeasure } from 'react-use';

import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { searchActions } from '../../../../search.actions';

import styles from './searchResultsPagination.module.scss';

type SearchResultsPaginationProps = {
  pageCount: number;
  currentPage: number;
};

/** Represents a component that is a wrapper for the pagination component */
export const SearchResultsPagination = ({
  ...props
}: SearchResultsPaginationProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const pageRangeAdjusted = useMemo(
    () => (width > 40 ? Math.floor(width / 40) : 6),
    [width],
  );

  const handlePageChange = (page: number) => {
    dispatch(searchActions.params.update({ page }));
  };

  return (
    <div ref={ref} className={styles.root}>
      <Pagination
        {...props}
        pageRangeDisplayed={pageRangeAdjusted}
        onPageChange={handlePageChange}
      />
    </div>
  );
};
